module.exports = __webpack_public_path__ + "static/media/res1.da527048.png";